import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Callback from './components/Callback.vue';
import store, { LOGIN, IS_LOGGED_IN } from '@/store';

// Views
import ErrorPage from '@/views/error/ErrorPage.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/callback',
      name: 'callback',
      component: Callback
    },
    {
      path: '/not-found',
      name: 'error',
      component: ErrorPage
    },
    {
      path: '/exports/:id',
      name: 'home',
      component: Home
    },
    { path: '*', redirect: '/not-found' }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.path === '/callback' || store.getters[IS_LOGGED_IN]) {
    return next();
  }
  store.dispatch(LOGIN, to.path);
});

export default router;
